module.exports = __webpack_public_path__ + "img/smartphone-with-shield.d456dd1b.png";